import type { BlendCalculationOutcome } from '@shared';

/**
 * Run a blend calculation and decide whether its response is still valid for
 * the current selection epoch. Pure async helper so the in-flight race can be
 * tested without mounting React.
 */
export async function runBlendCalculationForEpoch(args: {
  startedEpoch: number;
  getCurrentEpoch: () => number;
  calculate: () => Promise<BlendCalculationOutcome>;
}): Promise<
  | { status: 'accepted'; outcome: BlendCalculationOutcome; epoch: number }
  | { status: 'stale'; epoch: number }
  | { status: 'error'; message: string; epoch: number; stale: boolean }
> {
  const { startedEpoch, getCurrentEpoch, calculate } = args;
  try {
    const outcome = await calculate();
    if (getCurrentEpoch() !== startedEpoch) {
      return { status: 'stale', epoch: startedEpoch };
    }
    return { status: 'accepted', outcome, epoch: startedEpoch };
  } catch (err) {
    const message =
      err instanceof Error ? err.message : 'Calculation failed.';
    const stale = getCurrentEpoch() !== startedEpoch;
    return { status: 'error', message, epoch: startedEpoch, stale };
  }
}
